import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { pushParams, resetParams } from 'dpl/actions/query_params';
import { FILTER_GENDER, RESULTS_TYPE } from 'dpl/constants/query_params';
import { GENDERS } from 'dpl/shared/constants/breeder_app';
import {
  ANALYTICS_VIEWS,
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEW_FEATURE_LOCATIONS
} from 'dpl/constants/analytics';
import { RESULTS_TYPES } from 'dpl/puppy_search_results/utils/constants';

import FilterPill from './FilterPill';

export default function GenderFilterButtons() {
  const dispatch = useDispatch();
  const queryParams = useSelector(state => state.queryParams);
  const { genderOptions } = useSelector(({ server }) => server);

  const analytics = {
    view: ANALYTICS_VIEWS.PUPPY_SEARCH_RESULTS,
    view_feature: ANALYTICS_VIEW_FEATURES.GENDER_FILTER_BUTTON,
    view_feature_location: ANALYTICS_VIEW_FEATURE_LOCATIONS.SEARCH_HEADER
  };

  function updateFilterValue(value) {
    dispatch(
      pushParams(
        { [RESULTS_TYPE]: RESULTS_TYPES.PUPPIES, [FILTER_GENDER]: value },
        { hash: true }
      )
    );
  }

  function handleGenderFilterClick(value) {
    const paramValue = queryParams[FILTER_GENDER];
    const genderFilterValues = genderOptions.map(go => go.value);
    const oppositeValue = genderFilterValues.find(v => v !== value) || '';

    if (paramValue === 'any') {
      updateFilterValue(oppositeValue);
    } else if (paramValue === value) {
      dispatch(resetParams(FILTER_GENDER, { hash: true }));
    } else if (paramValue === oppositeValue) {
      updateFilterValue('any');
    } else {
      updateFilterValue(value);
    }
  }

  function isSelected(opt) {
    const paramValue = queryParams[FILTER_GENDER];
    if (!paramValue) {
      return false;
    }
    if (paramValue === 'any' || opt === paramValue) {
      return true;
    }
    return false;
  }

  return (
    <>
      <FilterPill
        label="Female"
        onClick={() => handleGenderFilterClick(GENDERS.FEMALE)}
        isSelected={isSelected(GENDERS.FEMALE)}
        analytics={{ ...analytics, button_cta: GENDERS.FEMALE }}
      />
      <FilterPill
        label="Male"
        onClick={() => handleGenderFilterClick(GENDERS.MALE)}
        isSelected={isSelected(GENDERS.MALE)}
        analytics={{ ...analytics, button_cta: GENDERS.MALE }}
      />
    </>
  );
}
